import { render, staticRenderFns } from "./ClinicalItem.vue?vue&type=template&id=dcadc79a"
import script from "./ClinicalItem.vue?vue&type=script&lang=js"
export * from "./ClinicalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports